import { render, staticRenderFns } from "./OnlinePaymentList.vue?vue&type=template&id=1f36e08c&scoped=true&lang=pug&"
import script from "./OnlinePaymentList.vue?vue&type=script&lang=js&"
export * from "./OnlinePaymentList.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePaymentList.vue?vue&type=style&index=0&id=1f36e08c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36e08c",
  null
  
)

/* custom blocks */
import block0 from "./OnlinePaymentList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VLayout,VProgressCircular,VRow,VSimpleTable})
